export default "__VITE_ASSET__Bmo$KdC5__"